/* global */
import Vue from "vue";
import { trans } from "common/translate.js";

export const iconButton = Vue.directive("icon-button", {
  bind(el, binding) {
    const classNames = [
      "c-image-viewer-icon-button",
      "i-icon",
      "i-" + binding.value
    ];

    // Some old browsers don't support adding multiple classes (classList.add(a, b, c)) so a loop is needed.
    classNames.forEach(name => {
      el.classList.add(name);
    });
  },

  update(el, binding) {
    const oldIconClass = "i-" + binding.oldValue;
    const newIconClass = "i-" + binding.value;
    el.classList.remove(oldIconClass);
    el.classList.add(newIconClass);
  }
});


const setTitle = (el, binding) => {
  el.title = trans(binding.value);
};

export const iconButtonTitle = Vue.directive("icon-button-title", {
  bind: setTitle,
  update: setTitle
});



// WEBPACK FOOTER //
// ./src/frontend/common/image-viewer/image-viewer-icon-button.js